import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import React, { ComponentProps } from 'react';

import { Radio as BlocksRadio } from '~/components/blocks';

const Root = styled(BlocksRadio)<{ disabled?: boolean }>(({ theme, disabled }) =>
  css({
    ...(!disabled && {
      ['&:hover > div:first-of-type']: {
        border: theme.borders.patientNavy,
      },
      ['&:focus > div:first-of-type']: {
        border: theme.borders.patientNavy,
      },
    }),
    ['& > input']: {
      [':checked + div:first-of-type::after']: {
        backgroundColor: theme.colors.background.patientNavy,
      },
      [':focus-visible + div']: {
        border: theme.borders.patientNavy,
      },
    },
  }),
);

type Props = ComponentProps<typeof BlocksRadio>;

export const Radio = (props: Props) => {
  return <Root {...props} disabled={props.disabled} />;
};
